// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"67":"da129574","160":"7debbda1","301":"3fa85dc5"}[chunkId] + ".chunk.css";
};